import React from 'react';
import { DishesState } from './dishesState/DishesState';
import { DishesControlPanel } from './components/DishesControlPanel/DishesControlPanel';
import { Dishes } from './components/Dishes/Dishes';
import { ModalWindows } from './components/ModalWindows';
import { AdditionalControls } from './components/AdditionalControls';
import style from './index.module.scss';

export const DishesPageV2: React.FC = () => {
	return (
		<DishesState>
			<div className={style.container} data-test="DishesPage">
				<DishesControlPanel />
				<Dishes />
				<ModalWindows />
			</div>
			<AdditionalControls />
		</DishesState>
	);
};
